export default "__VITE_ASSET__25265f5a__"